export default __webpack_public_path__ + "static/media/STL_Postal_Ballot_Notice.dd367f18.pdf";